import Uom from './uom.container'

export default Uom